import apiFetch from '@wordpress/api-fetch';
import { useState, useEffect } from '@wordpress/element';
import classNames from 'classnames';

export default function Block() {
  const [menu, setMenu] = useState(null);
  const [showMenu, setShowMenu] = useState(false);

  useEffect(() => {
    apiFetch({ path: 'fav/v1/menus/header' }).then((data) => {
      setMenu(data);
    });
  }, []);

  return (
    <>
      <div className="right flex items-center justify-end">
        <div>
          <div
            className="w-[26px] cursor-pointer block relative z-[6] group"
            onClick={() => setShowMenu(!showMenu)}
          >
            <span className="block bg-black rounded-[6px] h-[3px] mb-1 duration-200 w-[26px] group-hover:w-[12px] group-[.active]:w-[24px] group-[.active]:rotate-45 group-[.active]:absolute group-[.active]:top-0 group-[.active]:bottom-0 group-[.active]:right-0 group-[.active]:left-0 group-[.active]:origin-center"></span>
            <span className="block bg-black rounded-[6px] h-[3px] mb-1 duration-200 w-[12px] group-hover:w-[22px] group-[.active]:bg-transparent"></span>
            <span className="block bg-black rounded-[6px] h-[3px] mb-0 duration-200 w-[22px] group-hover:w-[26px] group-[.active]:w-[24px] group-[.active]:-rotate-45 group-[.active]:absolute group-[.active]:top-0 group-[.active]:bottom-0 group-[.active]:right-0 group-[.active]:left-0 group-[.active]:origin-center"></span>
          </div>
        </div>
      </div>
      {
        showMenu && (
          <div className="absolute top-0 left-0 right-0 px-4 py-6 z-[11]">
            <div className="flex items-center">
              <svg
                className="cursor-pointer"
                onClick={() => setShowMenu(!showMenu)}
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <line x1="2.06066" y1="2.01077" x2="18.7749" y2="18.7251" stroke="#000000" stroke-width="3"/>
                <line x1="1.22547" y1="18.7251" x2="17.9398" y2="2.01077" stroke="#000000" stroke-width="3"/>
              </svg>
            </div>
          </div>
        )
      }
      <div
        className={classNames('fixed top-0 left-0 right-0 bottom-0 bg-[#000]/30 backdrop-blur z-[10] translate-x-[-100vw] duration-500', {
          '!translate-x-[0vw]': showMenu,
        })}
      >
        <div className="bg-white h-full flex flex-col items-center justify-center">
          <div>
            {
              menu?.items.map(item => (
                <a
                  key={item.id}
                  className="block p-4 text-center hover:text-[#bb9e40] duration-200 font-medium"
                  href={item.url}
                >
                  {item.title}
                </a>
              ))
            }
          </div>
        </div>
      </div>
    </>
  )
}
